export default __webpack_public_path__ + "static/media/rightArrow.aea0d8c5.svg";